// removed by extract-text-webpack-plugin
module.exports = {"mainDiv":"_3iIt5E4WEbBvwcVKgbWnKQ","mainDivAudioteka":"_2XE0fiEl1SmmC-S47L3YUm","mainDivContact":"_2uszw7t8IzYvpOKJVtqhL","contactSpan":"_2_tH_jdR-uba_zGjalyxjB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CallToActionBtn/CallToActionBtn.css
// module id = 35
// module chunks = 0